// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3XOdF","description":"PatientConsentPreview_description__Pe67Z"};